import type {
  AccessAssignment,
  WorkbookAccessSettings,
} from "@/payroll/workbook-access/types";
import { areaName, workingFromSettings } from "@/payroll/workbook-access/utils";

export const getAccessSummary = (
  settings: WorkbookAccessSettings,
  userId: string,
) => {
  const working = workingFromSettings(settings, false);
  const rows = working.assignments.filter((row) => row.user_id === userId);
  const full = rows.find((row) => row.full_workbook_access);
  const primary = full ?? rows[0];
  const scope = (row: AccessAssignment) =>
    row.full_workbook_access
      ? "Whole workbook"
      : areaName(row.access_key, working.keySettings, settings.access_keys);
  const levels = new Set(rows.map((row) => row.access_level));
  const level =
    full?.access_level === "edit"
      ? "Edit"
      : levels.size > 1
        ? "Mixed levels"
        : primary?.access_level === "edit"
          ? "Edit"
          : "View";
  return {
    scope: primary ? scope(primary) : "No access",
    full: !!full,
    empty: !primary,
    extraCount: full ? 0 : Math.max(0, rows.length - 1),
    rights: [level, rows.some((row) => row.approval_access) && "Approves"]
      .filter(Boolean)
      .join(" · "),
    detail: rows
      .map(
        (row) =>
          `${scope(row)}: ${row.access_level === "edit" ? "Edit" : "View"}${row.approval_access ? ", approves" : ""}`,
      )
      .join("\n"),
  };
};
